import React from "react";
import { faLeaf, faSun } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export default function Notation() {
  return (
    <div className="container py-10 mt-20 custom-bg-gray">
      <div className="grid grid-cols-1 md:grid-cols-2">
        <div className="col-span-1">
          <img
            src={require("../../images/icon-gray.jpg")}
            alt="Icon"
            className="w-60 md:w-3/4 mt-10 mx-auto rounded-xl duration-300 hover:scale-105"
          />
        </div>
        <div className="col-span-1 flex justify-center items-center">
            <div className="text-center w-10/12">
          <div className="grid grid-cols-1">
            <div className="col-span-1">
              <h5 className="text-lg text-white md:text-slate-400">
                Lorem ipsum, dolor sit amet consectetur adipisicing elit.
              </h5>
            </div>
          </div>

          <div className="grid grid-cols-10 mt-3">
            <div className="col-span-1">
              <FontAwesomeIcon icon={faSun} className="w-6 h-6 p-2 text-white bg-lime-500 rounded-full" />
            </div>
            <div className="col-span-1">
              <FontAwesomeIcon icon={faSun} className="w-6 h-6 p-2 text-white bg-lime-500 rounded-full" />
            </div>
            <div className="col-span-1">
              <FontAwesomeIcon icon={faSun} className="w-6 h-6 p-2 text-white bg-lime-500 rounded-full" />
            </div>
            <div className="col-span-1">
              <FontAwesomeIcon icon={faSun} className="w-6 h-6 p-2 text-white bg-lime-500 rounded-full" />
            </div>
            <div className="col-span-1">
              <FontAwesomeIcon icon={faSun} className="w-6 h-6 p-2 text-white bg-lime-500 rounded-full" />
            </div>
            <div className="col-span-1">
              <FontAwesomeIcon icon={faSun} className="w-6 h-6 p-2 text-white bg-lime-500 rounded-full" />
            </div>
            <div className="col-span-1">
              <FontAwesomeIcon icon={faSun} className="w-6 h-6 p-2 text-white bg-lime-500 rounded-full" />
            </div>
            <div className="col-span-1">
              <FontAwesomeIcon icon={faSun} className="w-6 h-6 p-2 text-lime-500" />
            </div>
            <div className="col-span-1">
              <FontAwesomeIcon icon={faSun} className="w-6 h-6 p-2 text-lime-500" />
            </div>
            <div className="col-span-1">
              <FontAwesomeIcon icon={faSun} className="w-6 h-6 p-2 text-lime-500" />
            </div>
          </div>

          <div className="grid grid-cols-1 mt-8">
            <div className="col-span-1">
              <h5 className="text-lg text-white md:text-slate-400">
                Lorem ipsum, dolor sit amet consectetur adipisicing elit.
              </h5>
            </div>
          </div>

          <div className="grid grid-cols-10 mt-3">
            <div className="col-span-1">
              <FontAwesomeIcon icon={faLeaf} className="w-6 h-6 p-2 text-white bg-lime-500 rounded-full" />
            </div>
            <div className="col-span-1">
              <FontAwesomeIcon icon={faLeaf} className="w-6 h-6 p-2 text-white bg-lime-500 rounded-full" />
            </div>
            <div className="col-span-1">
              <FontAwesomeIcon icon={faLeaf} className="w-6 h-6 p-2 text-white bg-lime-500 rounded-full" />
            </div>
            <div className="col-span-1">
              <FontAwesomeIcon icon={faLeaf} className="w-6 h-6 p-2 text-white bg-lime-500 rounded-full" />
            </div>
            <div className="col-span-1">
              <FontAwesomeIcon icon={faLeaf} className="w-6 h-6 p-2 text-white bg-lime-500 rounded-full" />
            </div>
            <div className="col-span-1">
              <FontAwesomeIcon icon={faLeaf} className="w-6 h-6 p-2 text-lime-500" />
            </div>
            <div className="col-span-1">
              <FontAwesomeIcon icon={faLeaf} className="w-6 h-6 p-2 text-lime-500" />
            </div>
            <div className="col-span-1">
              <FontAwesomeIcon icon={faLeaf} className="w-6 h-6 p-2 text-lime-500" />
            </div>
            <div className="col-span-1">
              <FontAwesomeIcon icon={faLeaf} className="w-6 h-6 p-2 text-lime-500" />
            </div>
            <div className="col-span-1">
              <FontAwesomeIcon icon={faLeaf} className="w-6 h-6 p-2 text-lime-500" />
            </div>
          </div>
            </div>
        </div>
      </div>
    </div>
  );
}
